<template>
  <div class="main-header-right row m-0">
    <div class="main-header-left">
      <SideBar />
    </div>
  </div>
  <NavView v-if="!sidebarIsVisible" />
</template>
<script>

import NavView from './navView.vue';
import SideBar from "../header/sidebar.vue"

export default {
  emits: ['clicked'],
  components: { NavView, SideBar },
  data() {
    return {
      sidebarIsVisible: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.sidebarIsVisible = !this.sidebarIsVisible;
      document.getElementById("main").style.marginLeft = "0px";
    },
    closeSidebar() {
      this.sidebarIsVisible = true;
    },
  },
}
</script>